var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var withRouter = require('react-router').withRouter;
var ConditionNavListItem = require('./condtionNavListItem.jsx');

var CondtionNavList = createReactClass({
    mixins: [PureRenderMixin],

    handleChange: function(e){
        this.props.router.push('/conditions/' + e.currentTarget.value);
    },

	render: function(){
        var conditionNavListNodes = this.props.conditions && this.props.conditions.map( function ( condition, i ) {
            return (
                <ConditionNavListItem
                    key={condition.name}
                    condition={condition}
                    activeCondition={this.props.activeCondition}
                    setActiveCondition={this.props.setActiveCondition}
                    clickTracking={this.props.clickTracking} />
            )
        }.bind(this) );

        var optionNodes = this.props.conditions && this.props.conditions.map( function ( condition, i ) {
            return (
                <option value={condition.friendlyUrl} key={condition.friendlyUrl}>{condition.displayName || condition.title}</option>
            )
        });

		return (
            <div className={this.props.className}>
                <div className="special-select">
					<select onChange={this.handleChange} value={this.props.activeCondition.friendlyUrl}>
						{optionNodes}
					</select>
					<span className="ion-ios-arrow-down"></span>

					<span className="current-option">{this.props.activeCondition.displayName || this.props.activeCondition.title}</span>
				</div>
                <ul className="special-menu-list">
                    {conditionNavListNodes}
                </ul>
            </div>
	    )
	}
});

module.exports = withRouter(CondtionNavList);



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/condtionNavList.jsx